import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IconModule } from 'src/components/icon/icon.module';

@Component({
  selector: 'app-layout-auth',
  templateUrl: './layout-auth.component.html',
  standalone: true,
  imports: [CommonModule, IconModule],
})
export class LayoutAuthComponent {
  @Input()
  isHeroHiddenOnMobile: boolean = false;
}
